import { Helmet } from "react-helmet-async";
import { Container, Typography, Stack } from "@mui/material";
import TenantSettings from "../sections/@dashboard/settings/TenantSettings";

export default function SystemPage() {
  return (
    <>
      <Helmet>
        <title> MA | System </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack mb={3}>
          <Typography variant="h4" gutterBottom>
            System
          </Typography>
        </Stack>
        <TenantSettings />
      </Container>
    </>
  );
}
